import React, { useState } from "react";
import styles from "./StaffTraining.module.css";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import {
  Dropdown,
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../components";
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";
import { LuEye, LuEyeOff } from "react-icons/lu";


const StaffTraining = () => {
  const navigate = useNavigate();
  const [AddContactModal, setAddContactModal] = useState(false);
  const [actions, setActions] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [filterModal, setFilterModal] = useState(false)
  const [station, setStation] = useState({
    value: "station",
    role: "station",
    id: 1,
  });
  const [mediaType, setMediaType] = useState({
    value: "Media Type",
    role: "Media Type",
    id: 1,
  });
  const [role, setRole] = useState({
    value: "Role",
    role: "Role",
    id: 1,
  });


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "250px",
      align: "center",

      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      width: "250px",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    {
      title: "Media Type",
      key: "media_type",
      dataIndex: "media_type",
      width: "200px",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Last Uploaded",
      key: "Status",
      dataIndex: "Status",
      width: "200px",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    {
      title: "",
      key: "action",
      dataIndex: "Button",
      width: "200px",

      render: (text, record) => (
        <SubmitButton
          title={"Continue"}
          btnClass={styles.tableBtn}
          onClick={() => navigate("/Staff/ViewTraining")}
          primary
        />
      ),
    },
  ];

  const data = [
    {
      No: "1",
      name: "Mixing SOPs",
      department: "Assembly",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "2",
      name: " Oven SOPs",
      department: "Oven",
      role: "Staff Member",
      media_type: "PDF",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "3",
      name: "Mixing SOPs",
      department: "Assembly",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "1",
      name: "Mixing SOPs",
      department: "Assembly",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "2",
      name: " Oven SOPs",
      department: "Oven",
      role: "Staff Member",
      media_type: "PDF",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "3",
      name: "Mixing SOPs",
      department: "Assembly",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
  ];



  const stationOpt = [

    {
      value: "station",
      role: "station",
      id: 1,
    },
    {
      value: "Mixing",
      role: "Mixing",
      id: 2,
    },
    {
      value: "Make Up",
      role: "Make Up",
      id: 3,
    },
    {
      value: "Proofing",
      role: "Proofing",
      id: 4,
    }, {
      value: "Chill",
      role: "Chill",
      id: 5,
    }, {
      value: "Oven",
      role: "Oven",
      id: 6,
    }, {
      value: "Assembly",
      role: "Assembly",
      id: 7,
    }, {
      value: "Packaging",
      role: "Packaging",
      id: 8,
    },
  ]

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Training Library"}
        onSearch={(e) => console.log(e.target.value)}
        showFilterIcon={true}
        showSubmitButton={false}
        rightControlsStyle={styles.rightControlsStyle}
        showSearch={true}
        onClickFilter={() => setFilterModal(true)}

      />
      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="No"
          rowClassName={styles.tableRow}
        />
      </div>
      <Modal
        open={isModal}
        onCancel={() => {
          setIsModal(false);
        }}
        onClickOkButton={() => navigate("/Staff/ViewTraining")}
        className={styles.modalCont}
        title={"Enter Supervisor Password"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setIsModal(false)}

      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <InputField
          className={styles.input}
          labelClass={styles.labelClass}
          label={"Password"}
          placeholder={"12●●●●●●●●●"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          rightIcon={
            passwordVisible ? (
              <LuEye size={20} color={"var(--input-icon)"} />
            ) : (
              <LuEyeOff size={20} color={"var(--input-icon)"} />
            )
          }
          onRightIconPress={() => setPasswordVisible(!passwordVisible)}
          type={passwordVisible ? "text" : "password"}
        />
      </Modal>


      {/* //////////////////// Filters ////////////////////// */}
      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <Dropdown
          // label={"Stations"}
          // labelClass={styles.DropDownLabel}
          value={station}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={stationOpt}
          onChange={(e) => setStation(e)}
        />
        <Dropdown
          // label={"Role"}
          // labelClass={styles.DropDownLabel}
          value={role}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Role",
              role: "Role",
              id: 1,
            },
            {
              value: "Supervisor",
              role: "Supervisor",
              id: 2,
            },
            {
              value: "Staff",
              role: "Staff",
              id: 3,
            },
          ]}
          onChange={(e) => setRole(e)}
        />
        <Dropdown
          // label={"Media Type"}
          // labelClass={styles.DropDownLabel}
          value={mediaType}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Media Type",
              role: "Media Type",
              id: 1,
            },
            {
              value: "Video",
              role: "Video",
              id: 2,
            },
            {
              value: "PDF",
              role: "PDF",
              id: 3,
            },
          ]}
          onChange={(e) => setMediaType(e)}
        />
      </Modal>

    </div>
  );
};

export default StaffTraining;
